/**
 * 检查页面是否更新
 * 原理 轮询请求域名页面(如果域名页面不是首页则需要修改fetch请求链接) 获取页面script标签 与已存的script对比是否相同来判断是否更新了
 */
import {
  MessageBox
} from 'element-ui'
import Vue from 'vue'

let lastSrcs; // 上次获取到的script地址
let scriptReg = new RegExp(`<script.*src=(?<src>.+).+></script>`,'gm')
let fetchUrl = window.location.origin + window.location.pathname;
/**
 * 获取最新页面中的script链接
 */
async function extractNewScripts() {
  const html = await fetch(fetchUrl+'?_timestamp=' + Date.now()).then(resp => resp.text());
  scriptReg.lastIndex = 0;
  let result = [];
  let match;
  while ((match = scriptReg.exec(html))) {
    result.push(match.groups.src)
  }
  return result;
}

async function needUpdate() {
  const newScripts = await extractNewScripts();
  if (!lastSrcs) {
    lastSrcs = newScripts;
    return false;
  }
  let result = false;
  if (lastSrcs.length !== newScripts.length) {
    result = true;
  }
  for (let i = 0; i < lastSrcs.length; i++) {
    if (lastSrcs[i] !== newScripts[i]) {
      result = true;
      break;
    }
  }
  lastSrcs = newScripts;
  return result;
}

const AUTOTIME = 60000; // 轮询时间

function autoRefresh(that) {
  if (process.env.NODE_ENV === 'development') {
    return
  }
  setTimeout(async () => {
    const willUpdate = await needUpdate();
    const $bus = Vue.prototype.$bus;
    if (willUpdate) {
      MessageBox({
        title: $bus.$ts('内容优化'),
        message: `1.${$bus.$ts('优化若干问题')}<br/>2.${$bus.$ts('修复部分BUG')}`,
        confirmButtonText: $bus.$ts('立即更新'),
        cancelButtonText: $bus.$ts('稍后更新'),
        type: 'warning',
        dangerouslyUseHTMLString: true
      }).then(() => {
        setTimeout(()=>{
          location.reload()
        },500)
      })
    }
    autoRefresh(that)
  }, AUTOTIME)
}

export default autoRefresh
